<div>
  <div tiimeIconProperty>
    <mat-icon svgIcon="icon-dossier"></mat-icon>
    <span>Dossier lié :</span>
  </div>
  @if (company(); as company) {
    <div tiimeProperty>
      <span class="italic ellipsis">
        {{ company.name }}
      </span>
      @if (displayNavigateToCompany()) {
        <button
          tiime-button
          icon
          color="primary"
          tiimeTooltip="Ouvrir le dossier dans un nouvel onglet"
          (click)="emitNavigateToCompany()"
        >
          <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
        </button>
      }
    </div>
  } @else {
    <button
      tiime-button
      color="primary"
      [disabled]="createCompanyDisabled()"
      [tiimeTooltip]="createCompanyTooltip()"
      (click)="emitCreateCompany()"
    >
      <mat-icon fontSet="fontastic" fontIcon="icon-ic-add-1"></mat-icon>
      Ajouter le dossier client
    </button>
  }
</div>
